{
  "name": "@uppy/golden-retriever",
  "description": "The GoldenRetriever Uppy plugin saves selected files in browser cache to seamlessly resume uploding after browser crash or accidentally closed tab",
  "version": "5.1.1",
  "license": "MIT",
  "type": "module",
  "sideEffects": [
    "lib/ServiceWorker.js"
  ],
  "scripts": {
    "build": "tsc --build tsconfig.build.json",
    "typecheck": "tsc --build",
    "test": "vitest run --silent='passed-only'",
    "test:e2e": "vitest run --project browser"
  },
  "keywords": [
    "file uploader",
    "restore files",
    "crash recovery",
    "golden retriever",
    "resumable uploads",
    "uppy",
    "uppy-plugin"
  ],
  "homepage": "https://uppy.io",
  "bugs": {
    "url": "https://github.com/transloadit/uppy/issues"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/transloadit/uppy.git"
  },
  "files": [
    "src",
    "lib",
    "dist",
    "CHANGELOG.md"
  ],
  "exports": {
    ".": "./lib/index.js",
    "./lib/ServiceWorker.js": "./lib/ServiceWorker.js",
    "./package.json": "./package.json"
  },
  "dependencies": {
    "@uppy/utils": "workspace:^",
    "lodash": "^4.17.21"
  },
  "peerDependencies": {
    "@uppy/core": "workspace:^"
  },
  "devDependencies": {
    "@uppy/core": "workspace:^",
    "@uppy/dashboard": "workspace:^",
    "@uppy/xhr-upload": "workspace:^",
    "@vitest/browser": "^3.2.4",
    "typescript": "^5.8.3",
    "vitest": "^3.2.4"
  }
}
